export const MESSAGE = 'Router error';

export class RouteError extends Error {
  constructor() {
    super(MESSAGE);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/error/route-error.ts